import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-update-emergency-info',
  templateUrl: './update-emergency-info.component.html',
  styleUrls: ['./update-emergency-info.component.scss']
})
export class UpdateEmergencyInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
